<p role="button">
  <fa-icon [ngClass]="{'hidden': layoutGrid}"  [icon]="faTh" (click)="changeLayout($event.target)"></fa-icon>
  <fa-icon [ngClass]="{'hidden': !layoutGrid}" [icon]="faList" (click)="changeLayout($event.target)"></fa-icon>
</p>
<div class="relative flex flex-col rounded-lg bg-white shadow-sm border border-slate-200" [ngClass]="{'gridL': layoutGrid}" >
  <div *ngFor="let progetto of progetti" role="button" class="text-slate-800 flex w-full items-center rounded-md p-3 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100">
    <!-- Card -->
    <div (click)="goToProgetto(progetto.id)"  class="flex flex-col h-full bg-white border border-slate-200 shadow shadow-slate-950/5 rounded-2xl overflow-hidden">
        <!-- Image -->
        <img class="object-contain h-48 w-full p-4 " [src]="apiUrl+'/assets/'+progetto.immagine" width="304" height="192" alt="Course 01" style="background-color: {{progetto.colore}}" m-8>
        <!-- Card Content -->
        <div class="flex-1 flex flex-col p-6">
            <!-- Card body -->
            <div class="flex-1">
                <!-- Header -->
                <!-- header class="mb-2">
                    <h2 class="text-xl font-extrabold leading-snug">
                        <p class="text-slate-900 focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300">
                            {{progetto.nome}}
                        </p>
                    </h2>
                </header -->
                <!-- Content -->
                <div class="text-sm text-slate-600 mb-8">
                    <p>{{progetto.descrizione}}.</p>
                </div>
            </div>
            <!-- Card footer -->
            <div class="flex justify-center space-x-2">
                <a href="{{progetto.website}}" target="_blank" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">{{progetto.website}}</a>
            </div>
        </div>
    </div>

  </div>
</div>
